
import { Box, Container, Grid } from "@mui/material";
import Content from "../content-box/Content";
import Link from "@mui/material";

function TravelSection() {
    const { travelData} = Content[0];
    return(
        <>
            <div>
                   <Box className="TravelSection templeBox py-lg-0 ">
                    <Container maxWidth="md">
                      <Grid container spacing={2} justifyContent="center">
                        <Grid size={12}>
                          <Box className="templeInnerHeading">
                            <h2>{Content[0].travelHeading}</h2>
                            <p>{Content[0].travelSubHeading}</p>
                          </Box>
                        </Grid>
                        <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                            <a href="hotel">
                             <Box className="TravelSection templeCardBox">
                            
                             <img src={travelData[0].image} alt={travelData[0].title} className="img-fluid hotel" />
                                            <h3>{travelData[0].title}</h3>
                                            
                                        </Box>
                                        </a>
                        </Grid>
                        <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}>
                            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                            <a href="coming-soon">
                                <Box className="TravelSection templeCardBox boadRide">
                                    <img src={travelData[1].image} alt={travelData[1].title} className="img-fluid" />
                                    <h3>{travelData[1].title}</h3>
                                </Box>
                                </a>
                            </Grid>
                            <Grid container spacing={2}>
                            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <a href="coming-soon">
                                <Box className="TravelSection templeCardBox flightBook mt-3">
                                    <img src={travelData[2].image} alt={travelData[2].title} className="img-fluid" />
                                    <h3>{travelData[2].title}</h3>
                                </Box>
                                </a>
                            </Grid>
                            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <a href="coming-soon">
                                <Box className="TravelSection templeCardBox cabBook mt-3">
                                    <img src={travelData[3].image} alt={travelData[3].title} className="img-fluid" />
                                    <h3>{travelData[3].title}</h3>
                                </Box>
                                </a>
                            </Grid>
                            </Grid>
                        </Grid>
                  </Grid>
                  </Container>
                  </Box>
                </div>
        </>
    )
}

export default TravelSection;